import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.commonApiUrl;

const commonStoreModule = {
  namespaced: true,

  state: {
    comCdList: [],
  },
  mutations: {
    'SET_STORE_COM_CD_LIST' (state, comCdList) {
      comCdList === '' ? state.comCdList = [] : state.comCdList = comCdList;
    },
  },
  actions: { // /common/code/role/list/:grpCd
    getComCdList: async ({commit}, params) => {
      try {
        const response = await axios.get(`${baseURI}/common/code/list/${params.grpCd}`);
        // console.log(response.data);
        commit('SET_STORE_COM_CD_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        throw err;
      }
    },

    getComCdRoleList: async ({commit}, params) => {
      try {
        const response = await axios.get(`${baseURI}/common/code/role/list/${params.grpCd}`);
        // console.log(response.data);
        commit('SET_STORE_COM_CD_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        throw err;
      }
    },
  },
  getters: {
    comCdList: state => state.comCdList,
  },
};

export default commonStoreModule;
